import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import styled from "styled-components";
import { Link as RouteLink } from "react-router-dom";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import { IntegrationCategories } from "src/components/template/constants";
import { useActiveIntegrationsTeams } from "src/scenes/teams/dashboard/active-integrations-provider-teams";

const BootstrapButton = styled(IconButton)({
    boxShadow: "none",
    marginRight: "9px",
    marginLeft: "9px",
    borderRadius: "6px",
    height: "34px",
    backgroundColor: "#2e2e2e",
    "&:hover": {
        backgroundColor: "#2e2e2e",
        borderColor: "#0062cc",
        boxShadow: "none",
    },
    "&:active": {
        boxShadow: "none",
        backgroundColor: "black",
    },
    "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(255,152,0,.07)",
    },
});

const InvalidIntegrationButton = ({
    dependencies,
    isTeams,
}: {
    dependencies: IntegrationCategories[];
    isTeams: boolean;
}) => {
    // (isJiraIntegrated && jiraInvalid) ||
    // (isNotionIntegrated && notionInvalid)
    const [invalid, setInvalid] = React.useState(false);
    const { isIntegrated, isInvalid } = isTeams
        ? useActiveIntegrationsTeams()
        : useActiveIntegrations();

    React.useEffect(() => {
        let temp = false;
        if (
            dependencies &&
            dependencies.length &&
            dependencies.includes(IntegrationCategories.git)
        ) {
            temp =
                temp ||
                (isIntegrated.gitlab && isInvalid.gitlab) ||
                (isIntegrated.github && isInvalid.github);
        }
        if (
            dependencies &&
            dependencies.length &&
            dependencies.includes(IntegrationCategories.pm)
        ) {
            temp =
                temp ||
                (isIntegrated.jira && isInvalid.jira) ||
                (isIntegrated.notion && isInvalid.notion);
        }
        setInvalid(temp);
    }, [isInvalid, isIntegrated]);

    if (!invalid) return null;
    return (
        <BootstrapButton
            aria-label="delete"
            size="small"
            onClick={(e) => {
                e.stopPropagation();
            }}
            component={RouteLink}
            to="/integrations"
        >
            <Tooltip title="A required integration has been invalidated. You might be seeing partial or missing data.">
                <LinkOffIcon color="warning" />
            </Tooltip>
        </BootstrapButton>
    );
};
export default InvalidIntegrationButton;
